//
// This file is AUTO-GENERATED by protoc-gen-ts.
// Do not modify it manually.
///
import api from '../../api'
import * as googleTypes from '../../googleTypes'
import { Empty as arangodb_cloud_common_v1_Empty } from '../../common/v1/common'
import { Version as arangodb_cloud_common_v1_Version } from '../../common/v1/common'

// File: dashboard/v1/dashboard.proto
// Package: arangodb.cloud.dashboard.v1

// DashboardService is the API used for the dashboard.
export interface IDashboardService {
  // Get the current API version of this service.
  // Required permissions:
  // - None (authenticated only)
  GetAPIVersion: (req?: arangodb_cloud_common_v1_Empty) => Promise<arangodb_cloud_common_v1_Version>;
  
  // Get the runtime version of this service.
  // This is the same info as we expose on window.VERSION and can be used to see if the latest version is loaded in the browser.
  // Required permissions:
  // - None (authenticated only)
  GetVersion: (req?: arangodb_cloud_common_v1_Empty) => Promise<arangodb_cloud_common_v1_Version>;
}

// DashboardService is the API used for the dashboard.
export class DashboardService implements IDashboardService {
  // Get the current API version of this service.
  // Required permissions:
  // - None (authenticated only)
  async GetAPIVersion(req?: arangodb_cloud_common_v1_Empty): Promise<arangodb_cloud_common_v1_Version> {
    const path = `/api/dashboard/v1/api-version`;
    const url = path + api.queryString(req, []);
    return api.get(url, undefined);
  }
  
  // Get the runtime version of this service.
  // This is the same info as we expose on window.VERSION and can be used to see if the latest version is loaded in the browser.
  // Required permissions:
  // - None (authenticated only)
  async GetVersion(req?: arangodb_cloud_common_v1_Empty): Promise<arangodb_cloud_common_v1_Version> {
    const path = `/api/dashboard/v1/version`;
    const url = path + api.queryString(req, []);
    return api.get(url, undefined);
  }
}
